'use strict';

export var anywhereService = function (configService, httpService) {
    
    var getAnywhereLaunchSettings = function (ticketStepId, ticketId, researchPlayerType) {
        return httpService.sendToApi({
                method: 'GET',
                headers: {
                    'TicketId': ticketId
                }
            },
            `anywhere/launchsettings/${ticketStepId}/${researchPlayerType}`
        ).then(res => {
            return res;
        });
    }

    var getStoreManifest = function (storeManifestUrl) {
        return httpService.send({
            method: 'GET',
            url: storeManifestUrl
        }).then(res => {
            return res;
        })
    }

    var preload = function (url) {

        return httpService.sendWithoutErrorHandling({
            method: 'GET',
            url: url
        }).then(res => {
            return res;
        })
    }

    return {
        getAnywhereLaunchSettings: getAnywhereLaunchSettings,
        getStoreManifest: getStoreManifest,
        preload: preload
    };
};

anywhereService.$inject = ['configService', 'httpService'];